import { Layout } from 'react-admin';
import { MyLeftBarMenu } from './menu-leftbar.js';
import MyAppBar from "./app-bar.js";

export const MyLayout = (props) => <Layout {...props} menu={MyLeftBarMenu} appBar={MyAppBar} />;